import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { Grid } from '@mui/material';
import BackNextButtons from './back_next_buttons';
import HeightUnitChanger from '../common/height_unit_changer';
import HeightInput from '../common/height_input';

const SpaceOnboardingStepHeight = ({
  // sharedProgrammeTitle,
  height,
  setHeight,
  heightUnits,
  setHeightUnits,
  completionPercentage,
  onNext,
  onBack,
}) => {
  const [isValidInput, setIsValidInput] = useState(false);

  return (
    <div className="onboarding-wizard">
      {/* <div className="onboarding-wizard-title">{sharedProgrammeTitle}</div> */}
      <div className="onboarding-wizard-step">
        <div className="step-heading">
          <div className="completion-percentage">
            {completionPercentage}% complete
          </div>
          <div className="step-title">What is your height?</div>
        </div>
        <div
          className="step-content light-background"
          style={{ marginTop: '50px' }}>
          <Grid container>
            <HeightInput
              heightCm={height}
              heightUnits={heightUnits}
              onChange={setHeight}
              onSetIsValidInput={setIsValidInput}
            />
            <Grid
              item
              xs={12}
              style={{
                marginTop: '20px',
                fontSize: '14px',
                fontWeight: 'bold',
                textDecoration: 'none',
              }}>
              <HeightUnitChanger
                heightUnits={heightUnits}
                setHeightUnits={setHeightUnits}
              />
            </Grid>
          </Grid>
        </div>
        <BackNextButtons
          nextButtonDisabled={!isValidInput}
          onNext={() => onNext(height)}
          onBack={onBack}
        />
      </div>
    </div>
  );
};

SpaceOnboardingStepHeight.propTypes = {
  // sharedProgrammeTitle: PropTypes.string.isRequired,
  height: PropTypes.number,
  setHeight: PropTypes.func.isRequired,
  heightUnits: PropTypes.string.isRequired,
  setHeightUnits: PropTypes.func.isRequired,
  completionPercentage: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

SpaceOnboardingStepHeight.defaultProps = {
  height: null,
};

export default SpaceOnboardingStepHeight;
